import React from "react";

const S = ({ children, size = 16, strokeWidth = 1.8, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    style={{ display: "block", flexShrink: 0 }}
    {...props}
  >
    {children}
  </svg>
);

export const IconSidebar = (p) => (
  <S {...p}><rect x="3.5" y="4.5" width="17" height="15" rx="2.5" /><path d="M9.5 4.5v15" /></S>
);
export const IconPlus = (p) => <S {...p}><path d="M12 5v14M5 12h14" /></S>;
export const IconMore = (p) => (
  <S {...p}><circle cx="5.5" cy="12" r="1" fill="currentColor" /><circle cx="12" cy="12" r="1" fill="currentColor" /><circle cx="18.5" cy="12" r="1" fill="currentColor" /></S>
);
export const IconPencil = (p) => <S {...p}><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="M13.5 6.5l4 4" /></S>;
export const IconTrash = (p) => (
  <S {...p}><path d="M4.5 7h15" /><path d="M9.5 7V4.5h5V7" /><path d="M6.5 7l1 12.5h9l1-12.5" /></S>
);
export const IconLink = (p) => (
  <S {...p}><path d="M10 14a4 4 0 005.66 0l3-3a4 4 0 00-5.66-5.66l-1 1" /><path d="M14 10a4 4 0 00-5.66 0l-3 3a4 4 0 005.66 5.66l1-1" /></S>
);
export const IconSparkle = (p) => (
  <S {...p}><path d="M12 3.5l1.9 5.1 5.1 1.9-5.1 1.9L12 17.5l-1.9-5.1L5 10.5l5.1-1.9z" /><path d="M18.5 15.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7z" /></S>
);
export const IconWhiteboard = (p) => (
  <S {...p}><rect x="3.5" y="4" width="17" height="11.5" rx="1.5" /><path d="M8 19.5l4-4 4 4" /><path d="M7.5 11.5l3-3 2.5 2 3.5-3.5" /></S>
);
export const IconCalendar = (p) => (
  <S {...p}><rect x="4" y="5.5" width="16" height="14" rx="2" /><path d="M4 10h16M8.5 3.5v4M15.5 3.5v4" /></S>
);
export const IconDesk = (p) => (
  <S {...p}><path d="M3.5 9.5h17" /><path d="M5.5 9.5v10M18.5 9.5v10" /><path d="M13 9.5v5h5.5" /><rect x="7.5" y="4" width="7" height="5.5" rx="1" /></S>
);
export const IconBookshelf = (p) => (
  <S {...p}><path d="M5 4.5v15M9 4.5v15" /><path d="M13 6l3.5-1 3 14-3.5 1z" /><path d="M3.5 19.5h17" /></S>
);
export const IconBulletin = (p) => (
  <S {...p}><rect x="3.5" y="5" width="17" height="14" rx="1.5" /><path d="M8 9.5h4M8 13h7" /><circle cx="16.5" cy="9.5" r="1" fill="currentColor" /></S>
);
export const IconCouch = (p) => (
  <S {...p}><path d="M5.5 11V8.5a2 2 0 012-2h9a2 2 0 012 2V11" /><path d="M3.5 13a2 2 0 014 0v1.5h9V13a2 2 0 014 0v4.5h-17z" /><path d="M5.5 17.5v2M18.5 17.5v2" /></S>
);
export const IconPainting = (p) => (
  <S {...p}><rect x="4" y="4.5" width="16" height="15" rx="1.5" /><path d="M4 16l4.5-4.5 3.5 3.5 2.5-2.5L20 18" /><circle cx="15.5" cy="9" r="1.5" /></S>
);

export const SURFACE_ICONS = {
  whiteboard: IconWhiteboard,
  calendar: IconCalendar,
  desk: IconDesk,
  bookshelf: IconBookshelf,
  bulletin_board: IconBulletin,
  couch: IconCouch,
  painting: IconPainting,
};
